module.exports = __webpack_public_path__ + "static/media/homepageBg2.182aafcd.jpg";